import { render, staticRenderFns } from "./ListInvoices.vue?vue&type=template&id=594b8570&scoped=true"
import script from "./ListInvoices.vue?vue&type=script&lang=js"
export * from "./ListInvoices.vue?vue&type=script&lang=js"
import style0 from "./ListInvoices.vue?vue&type=style&index=0&id=594b8570&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594b8570",
  null
  
)

export default component.exports